import {isArray, isNumber} from 'ts-opt';

/** Nullable numeric pair used by exterior trait weights. */
export type NullableNumberPair = [number | null, number | null];

/**
 * Checks whether a value is a nullable numeric pair.
 *
 * @param x Value to inspect.
 * @returns `true` when the value is a pair of numbers.
 */
export const isNullableNumberPair = (x: unknown): x is NullableNumberPair =>
    isArray(x) && x.length === 2 && isNumber(x[0]) && isNumber(x[1]); // eslint-disable-line no-magic-numbers
